import PathfindingVisualizer from "./pathfindingVisualizer/pathfindingVisualizer";

function App() {
  return (
    <div>
      <PathfindingVisualizer />
    </div>
  );
}

export default App;
